export default "__VITE_ASSET__CWWzVdHQ__"